export const timeFrames = [
	{ name: "1 Week", value: 1, days: 7 },
	{ name: "2 Weeks", value: 2, days: 14 },
	{ name: "1 Month", value: 3, days: 30 },
	{ name: "3 Months", value: 4, days: 90 },
	{ name: "6 Months", value: 5, days: 180 },
	{ name: "1 Year", value: 6, days: 365 },
	{ name: "2 Years", value: 7, days: 730 },
];
